<template>
    <div class="our-section">
      <div class="hero-content">
        <h1 class="title-about">Por qué Talentinus</h1>
        <p class="description-about">
            Talentinus te ayuda a entender a tu hijo desde lo que realmente siente y necesita, 
            no desde lo que debería ser.
        </p>
        <p class="description-about">
          Tu hijo(a) se sentirá comprendido(a), descubriendo con claridad quién es y qué 
            camino le hace sentido, recuperando la motivación para construir su futuro con propósito, 
            en lugar de adaptarse por presión a un mundo que cambia sin aviso.
        </p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AboutUsSection'
  }
  </script>
  
  <style scoped>
  .our-section {
    width: 100%;
    height: 1200px;
    background: url('../../assets/img/DTS_DEEP_SPA_Fanette_Guilloud_Photos_ID10975\ \(1\).jpg') no-repeat center center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
  }
  
  .hero-content {
    display: flex;
    max-height: 1400px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    text-align: center;
  }
  
  @media (max-width: 768px) {
  .our-section {
    height: auto;
    min-height: 180px;
    padding: 10px 0;
    background-size: cover;
  }
  .hero-content {
    max-height: none;
    gap: 14px;
    padding: 0 2vw;
  }
  .title-about {
    font-size: 1.1rem;
    padding: 0 16px;
    line-height: 1.15;
    word-break: break-word;
    margin-bottom: 12px; /* <-- Agrega separación debajo del título */
    margin-top: 80px !important;  /* <-- Baja el título un poco desde arriba */
  }
  .description-about {
    font-size: 0.97rem;
    padding: 0 2vw;
    line-height: 1.3;
    word-break: break-word;
  }
}
  
  </style>
